module.exports = __webpack_public_path__ + "static/img/wechatcode.de21773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechatcode.jpg
// module id = fXbW
// module chunks = 1